<!-- <div class="content-wrapper container-xxl p-0"> -->
<div class="content-wrapper">
	<div class="content-body">
		<!-- content-header component -->
		<app-content-header [contentHeader]="contentHeader"></app-content-header>


		<!-- Modal importacao -->
		<ng-template #modalBasic let-modal>
			<div class="modal-header">
				<h2 class="modal-title" id="myModalLabel1">Importar Chips</h2>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" tabindex="0" ngbAutofocus>
				<div class="form-group" style="width: 10%; min-width: 140px;" *ngIf="!resultado_show">
					<label for="basicInputFile">Separador:</label>
					<select [(ngModel)]="separador" name="separador" class="form-control" id="basicSelect" required>
						<option value=""></option>
						<option value=";">;</option>
						<option value=",">,</option>
						<option value="\n">ENTER</option>
					</select>
				</div>
				<div class="form-group" *ngIf="!resultado_show">
					<label for="basicInputFile">Selecione um aquivo CSV com Chips:</label>
					<div class="custom-file">
						<input [disabled]="spinnerImportar" class="custom-file-input" #file id="file" type="file"
							(change)="handleFileInput($event)">
						<label class="custom-file-label" #labelImport for="fileToUpload">{{fileToUpload != null ?
							fileToUpload.name : "Nenhum arquivo selecionado"}}</label>
					</div>
					<button class="btn btn-primary mt-1"
						[disabled]="fileToUpload == null || spinnerImportar || separador == ''"
						(click)="importarCsv(fileToUpload)">
						<span *ngIf="spinnerImportar" class="spinner-border spinner-border-sm mr-1"></span>
						<span>Importar</span>
					</button>
				</div>
				<div *ngIf="resultado_show">
					<!-- <h3 class="mt-1"><b>RESULTADO:</b></h3> -->
					<!-- DATATABLE -->
					<ngx-datatable class="bootstrap core-bootstrap" [rowHeight]="58" [limit]="500" columnMode="force"
						[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
						[loadingIndicator]="spinnerImportar" style="box-shadow: none" [rows]="resultado_importacao"
						[scrollbarH]="true">

						<!-- COLUNA -->
						<ngx-datatable-column [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>RESULTADO</h4>
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="font-weight-bold">{{row.item}}</span>
							</ng-template>
						</ngx-datatable-column>

					</ngx-datatable>
				</div>
			</div>
		</ng-template>
		<!-- / Modal importacao-->

		<section id="sample-page">
			<div class="row">
				<div id="stepper1" class="bs-stepper horizontal-wizard-example"></div>
				<div class="col-12">
					<div class="card">
						<div class="card-body pb-1">
							<div class="row mb-5">
								<div class="col-12">
									<button class="btn btn-primary float-left mr-1 mt-1" rippleEffect
										(click)="modalOpen(modalBasic)">
										<i data-feather="file" class="mr-0 mr-sm-1"></i><span
											class="d-none d-sm-inline-block">Importar com <b>CSV</b></span>
									</button>
									<!-- <a csvLink [data]="exportCSVData" class="btn btn-outline-secondary float-right mr-1 mt-1" rippleEffect>Exportar
												CSV</a> -->
								</div>
							</div>
							<form #cadastroForm="ngForm">
								<div class="card-body pb-1">
									<div class="row">
										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label>ICCID *</label>
												<input [(ngModel)]="chipInterface.icc_id" #Ref1="ngModel"
													class="form-ngModel" required type="text" name="iccid"
													class="form-control"
													[class.error]="!Ref1.valid && cadastroForm.submitted"
													placeholder="ICCID" />
												<span *ngIf="cadastroForm.submitted && Ref1.invalid"
													class="invalid-form">
													<small class="form-text text-danger" *ngIf="Ref1.errors.required">
														Campo Obrigatório!
													</small>
												</span>
											</div>
										</div>

										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label for="basicSelect">Operadora *</label>
												<select [(ngModel)]="chipInterface.id_operadora" #Ref2="ngModel"
													[class.error]="!Ref2.valid && cadastroForm.submitted"
													name="id_operadora" class="form-control" id="basicSelect" required>
													<option [value]="0">
														Selecione uma Operadora
													</option>
													<option [value]="item.id_operadora" *ngFor="let item of operadoras">
														{{item.operadora}}
													</option>
												</select>
												<span *ngIf="cadastroForm.submitted && Ref2.invalid"
													class="invalid-form">
													<small class="form-text text-danger" *ngIf="Ref2.errors.required">
														Selecione uma opção!
													</small>
												</span>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label>DDD *</label>
												<input [(ngModel)]="chipInterface.ddd" #Ref3="ngModel"
													class="form-ngModel" required type="text" name="ddd"
													class="form-control"
													[class.error]="!Ref3.valid && cadastroForm.submitted"
													placeholder="DDD" />
												<span *ngIf="cadastroForm.submitted && Ref3.invalid"
													class="invalid-form">
													<small class="form-text text-danger" *ngIf="Ref3.errors.required">
														Campo Obrigatório!
													</small>
												</span>
											</div>
										</div>

										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label for="basicSelect">Broker *</label>
												<select [(ngModel)]="chipInterface.id_broker" #Ref4="ngModel"
													[class.error]="!Ref4.valid && cadastroForm.submitted"
													name="id_broker" class="form-control" id="basicSelect" required>
													<option [value]="0">
														Selecione um Broker
													</option>
													<option [value]="item.id_broker" *ngFor="let item of brokers">
														{{item.broker}}
													</option>
												</select>
												<span *ngIf="cadastroForm.submitted && Ref4.invalid"
													class="invalid-form">
													<small class="form-text text-danger" *ngIf="Ref4.errors.required">
														Selecione uma opção!
													</small>
												</span>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label for="basicSelect">Contratante *</label>
												<select [(ngModel)]="chipInterface.id_contratante" #Ref4="ngModel"
													[class.error]="!Ref4.valid && cadastroForm.submitted"
													name="id_contratante" class="form-control" id="basicSelect"
													required>
													<option [value]="0">
														Selecione
													</option>
													<option [value]="1">
														Rastreei
													</option>
													<!-- <option [value]="item.id_broker" *ngFor="let item of brokers">
														{{item.nome}}
													</option> -->
												</select>
												<span *ngIf="cadastroForm.submitted && Ref4.invalid"
													class="invalid-form">
													<small class="form-text text-danger" *ngIf="Ref4.errors.required">
														Selecione uma opção!
													</small>
												</span>
											</div>
										</div>

										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label>APN *</label>
												<select [(ngModel)]="chipInterface.id_apn" name="id_apn"
													class="form-control" id="basicSelect">
													<option [value]="0">
														Selecione uma apn
													</option>
													<option [value]="item.id_apn" *ngFor="let item of apns">
														{{item.apn}}
													</option>
												</select>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label>Estoque *</label>
												<select [(ngModel)]="chipInterface.id_estoque" #Ref5="ngModel"
													[class.error]="!Ref5.valid && cadastroForm.submitted" required
													name="id_tipo_fluxo" class="form-control" id="basicSelect">
													<option [value]="1">
														Grupo 2E
													</option>
												</select>
												<span *ngIf="cadastroForm.submitted && Ref5.invalid"
													class="invalid-form">
													<small class="form-text text-danger" *ngIf="Ref5.errors.required">
														Selecione uma opção!
													</small>
												</span>
											</div>
										</div>
										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label>Modelo de Chip *</label>
												<select [(ngModel)]="chipInterface.id_modelo_chip" name="id_modelo_chip" required
													class="form-control" id="basicSelect">
													<option [value]="null">
														Selecione um Modelo
													</option>
													<option [value]="item.id_modelo_chip"
														*ngFor="let item of modelosChip">
														{{item.modelo}}
													</option>
												</select>
												<span *ngIf="cadastroForm.submitted && Ref5.invalid"
													class="invalid-form">
													<small class="form-text text-danger" *ngIf="Ref5.errors.required">
														Selecione uma opção!
													</small>
												</span>
											</div>
										</div>
									</div>

									<div class="row">

										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label>IP</label>
												<input [(ngModel)]="chipInterface.ip" #Ref3="ngModel"
													class="form-ngModel" type="text" name="ip" class="form-control"
													placeholder="IP" />
											</div>
										</div>
										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label>Personalização</label>
												<input [(ngModel)]="chipInterface.personalizacao" #Ref3="ngModel"
													class="form-ngModel" type="text" name="personalizacao"
													class="form-control"
													placeholder="Personalização" />
											</div>
										</div>
									</div>

									<div class="row">

										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label>Consumo</label>
												<input [(ngModel)]="chipInterface.consumo" #Ref3="ngModel"
													class="form-ngModel" type="text" name="Consumo" class="form-control"
													placeholder="Consumo" />
											</div>
										</div>

										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label for="basicSelect">Status *</label>
												<select [(ngModel)]="chipInterface.id_status" #Ref2="ngModel"
													name="id_status" class="form-control" id="basicSelect" required>
													<option value="1">Ativo</option>
													<option value="0">Inativo</option>
												</select>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label>Latitude</label>
												<input [(ngModel)]="chipInterface.latitude" #Ref3="ngModel"
													class="form-ngModel" type="text" name="latitude"
													class="form-control"
													placeholder="Latitude" />
											</div>
										</div>

										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label>Longitude</label>
												<input [(ngModel)]="chipInterface.longitude" #Ref3="ngModel"
													class="form-ngModel" type="text" name="longitude"
													class="form-control"
													placeholder="Longitude" />
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-md-6 col-12">
											<div class="form-group mb-2">
												<label>Lote</label>
												<input [(ngModel)]="chipInterface.lote" #Ref3="ngModel"
													class="form-ngModel" type="text" name="lote" class="form-control"
													placeholder="Lote" />
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-12 mt-50 ">
											<button routerLink="/chip/" class="btn btn-secondary botao-cancelar"
												rippleEffect>Cancelar</button>
											<button (click)="submitForm(cadastroForm)" type="submit"
												[disabled]="loading" class="btn btn-primary btn-next " rippleEffect>
												<span class="align-middle d-sm-inline-block d-none">Salvar</span>
												<span *ngIf="loading"
													class="spinner-border spinner-border-sm align-middle ml-sm-25 ml-0"></span>
												<span *ngIf="!loading">
													<i *ngIf="!loading" data-feather="arrow-right"
														class="align-middle ml-sm-25 ml-0"></i>
												</span>
											</button>
										</div>
									</div>
								</div>

							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</div>